import { CtCategory } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    name: {
      field: 'name',
      label: 'Name',
      validator: () => true,
      type: 'string',
      required: true,
      default: 'Default'
    },
    label: {
      field: 'label',
      label: 'Label',
      validator: () => true,
      type: 'string',
      required: false
    },
    parent: {
      field: 'parent',
      label: 'Parent',
      validator: () => true,
      type: 'UUID',
      required: false
    },
    type: {
      field: 'type',
      label: 'Type',
      validator: () => true,
      type: 'string',
      required: false
    }
  }

const state = {}
const getters = {}
const mutations = {}
const actions = {}
const options = {}

export default ContentModule<CtCategory>(
  ContentType.Category, 'Services/Directr', model,
  state,
  getters,
  mutations,
  actions,
  options)
